import React from 'react';
import { Box, Flex, Text } from '@cko/primitives';
import styled from 'styled-components';

const EMPTY_VIEW_TEST_ID = 'notifications-in-navigation-empty-view';

const Wrapper = styled(Flex)`
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  margin: 0 auto;
  width: 322px;
`;

export const EmptyView = () => (
  <Wrapper data-testid={EMPTY_VIEW_TEST_ID}>
    <Box marginBottom="var(--layout-soybean)">
      <Text font="var(--heading-sm)">No notifications</Text>
    </Box>
    <Text color="var(--base-text-secondary)" font="var(--body-xs)">
      You don't have any notifications yet, they'll show up here when you do.
    </Text>
  </Wrapper>
);
